"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = __importDefault(require("@rc-ex/core/lib/Utils"));
const SdkExtension_1 = __importDefault(require("@rc-ex/core/lib/SdkExtension"));
class DebugExtension extends SdkExtension_1.default {
    constructor(options = {}) {
        var _a;
        var _b;
        super();
        this.options = options;
        // eslint-disable-next-line no-console
        (_a = (_b = this.options).loggingAction) !== null && _a !== void 0 ? _a : (_b.loggingAction = (message) => console.debug(message));
    }
    async install(rc) {
        const request = rc.request.bind(rc);
        rc.request = async (method, endpoint, content, queryParams, config) => {
            if (!this.enabled) {
                return request(method, endpoint, content, queryParams, config);
            }
            const r = await request(method, endpoint, content, queryParams, config);
            this.options.loggingAction(Utils_1.default.formatTraffic(r));
            return r;
        };
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
    async revoke() { }
}
exports.default = DebugExtension;
//# sourceMappingURL=index.js.map